import React, { useRef, useEffect, useState } from "react";
import xss from "xss";
import Head from "./components/Head/Head";
import Pagination from "../Pagination";
import { isSafari } from "../../helpers/is-safari";

export default function Preview(props) {
    let { bookId } = props;
    let owned = props.elem?.dataset?.owned ? props.elem.dataset.owned : props.owned;
    let upcoming = props.elem?.dataset?.upcoming ? props.elem.dataset.upcoming : props.upcoming;
    upcoming = upcoming === "true";

    let sliderContentRef = useRef();

    let [data, setData] = useState({});

    const [currentPage, setCurrentPage] = useState(0);
    const [totalPage, setTotalPage] = useState(0);

    useEffect(() => {
        window.Dibook.preview.fetchPreview(bookId).then((response) => {
            if (response.status < 300) {
                setData(response.content.data);
                resetAll();
            }
        });
        window.onresize = () => resetAll();
    }, []);

    return (
        <div className="preview">
            <div className="preview__body">
                <div
                    className="preview__body__close"
                    onClick={() => {
                        window.Dibook.preview.close();
                        props.onClose?.();
                    }}
                >
                    <img
                        className="preview__body__close__img"
                        src="/images/icon/square-close-icon.svg"
                        alt="cross"
                    />
                </div>

                <div className="preview__body__slider">
                    <div
                        ref={sliderContentRef}
                        className="preview__body__slider__content"
                        dangerouslySetInnerHTML={{ __html: xss(data?.content) }}
                    ></div>
                </div>

                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPage}
                    onNextPage={goNext}
                    onPreviousPage={goPrev}
                    onPageSelected={goToPage}
                />

                <Head data={data} bookId={bookId} owned={owned} upcoming={upcoming} />
            </div>
        </div>
    );

    function goPrev() {
        if (currentPage > 0) {
            let nextPage = currentPage - 1;
            setCurrentPage(nextPage);
            scrollPage(nextPage);
        }
    }

    function goNext() {
        if (currentPage < totalPage - 1) {
            let nextPage = currentPage + 1;
            setCurrentPage(nextPage);
            scrollPage(nextPage);
        }
    }

    function goToPage(page) {
        if (page < 0 || page > totalPage - 1) return;
        setCurrentPage(page);
        scrollPage(page);
    }

    function scrollPage(page) {
        const is_safari = isSafari();

        let visibleContentWidth = sliderContentRef.current.getBoundingClientRect().width;
        if(is_safari)
            visibleContentWidth = sliderContentRef.current.getBoundingClientRect().height;

        if(is_safari)
            sliderContentRef.current.scrollTop = page * (visibleContentWidth);
        else
            sliderContentRef.current.scrollTo(page * (visibleContentWidth + 15), 0);
    }

    function resetAll() {
        const is_safari = isSafari();

        let visibleContentWidth = sliderContentRef.current.getBoundingClientRect().width;
        if(is_safari)
            visibleContentWidth = sliderContentRef.current.getBoundingClientRect().height;

        let allContentWidth = sliderContentRef.current.scrollWidth;
        if(is_safari) 
            allContentWidth = sliderContentRef.current.scrollHeight;

        let pageCount = allContentWidth / visibleContentWidth;
        setTotalPage(Math.round(pageCount));
        setCurrentPage(0);
        scrollPage(0);
        sliderContentRef.current.classList.remove("preview__body__slider__content__half-page");
    }
}
